<div class="heroBanner itim-background bgPrimary">
    <div class="container">
        <h1 class="text-center" style="background-color:rgba(24,60,71,0.8);color: white;" [innerHtml]="TUMIPageTitle"></h1>
    </div>
</div>

<!-- 
<div class="bgWhite discipleshipTitle">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-12 col-lg-12">
                <div class="coursePart mb-3 h-100">
                    <h1 class="colorWhite mt-2 mb-4 ml-5 text-center" [innerHtml]="TUMIPageTitle"></h1>
                    <span class="colorWhite mt-2 mb-4">
                        <div class="container">
                            <div class="content" [innerHtml]="TUMIPageDescription"></div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div> -->



<div class="bgWhite py-80">
    <div class="container">
        <!-- <h1 class="text-center mb-5" style="color: #f78e41;" [innerHtml]="TUMIPageTitle"></h1> -->
        
        <div class="row">
            <div class="col-12 col-md-12 col-lg-12 mb-3 mb-lg-0" [innerHtml]="TUMIPageDescription">
                
            </div>
            <!-- <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
                <div class="embed-responsive embed-responsive-16by9">
                    <iframe [src]="securityByPass('https://www.youtube.com/embed/'+getInvolvedYoutubeId)" 
                    allowfullscreen width="500px"></iframe>
                  </div>
            </div> -->
        </div>
       
    </div>
</div>
